export default "__VITE_ASSET__DgqoTL$v__"